import InputCheckbox from "./Input.Checkbox";

export default InputCheckbox;